<div class="ds-modal solicitud">
    <app-spinner
        [show]="!flagLoaded"
        [text]="'Cargando detalles de la solicitud...'"
        [type]="'fullscreen'"
        [color]="'#B1476A'" [trackColor]="'#4CA7C8'"
        [blurBackground]="true"
    ></app-spinner>

    <app-spinner
        [show]="exportandoPDFs"
        [text]="exportandoPDFsMensaje"
        [type]="'fullscreen'"
        [color]="'#B1476A'" [trackColor]="'#4CA7C8'"
        [blurBackground]="true"
    ></app-spinner>

    <div class="ds-accent"></div>

    <!-- ============ Cabecera ============ -->
    <div class="ds-modal__head">
        <span class="ds-modal__head-icon material-icons">how_to_reg</span>
        <div>
            <h2>Detalle Solicitud</h2>
            <p *ngIf="solicitud?._nro">
                Solicitud Nº {{ solicitud._nro }} · {{ solicitud?.lastState?.numberState | estadosPipe }}
            </p>
        </div>
        <span class="ds-modal__spacer"></span>
        <span class="ds-chip" *ngIf="flagLabelAprobado">APROBADA</span>
        <span class="ds-chip ds-chip--danger" *ngIf="flagLabelRechazado">ANULADA</span>
        <button type="button" class="ds-icon-btn" (click)="closeModal()" aria-label="Cerrar">
            <span class="material-icons">close</span>
        </button>
    </div>

    <!-- ============ Cuerpo ============ -->
    <div class="ds-modal__body" *ngIf="flagLoaded">
        <div class="solicitud__grid">
            <!-- ---------- Columna izquierda ---------- -->
            <div class="solicitud__col">
                <app-ofertas-estado-detalle
                    seccion="contacto"
                    [solicitud]="solicitud"
                    [usuario]="usuario"
                    [beneficiario]="beneficiario"
                    [nombrePais]="nombrePais"
                    [estadoDocumentacion]="estadoDocumentacion"
                    [esSedeInscripcion]="esSedeInscripcion"
                ></app-ofertas-estado-detalle>

                <!-- Documentación - Fotos -->
                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">photo_library</span>
                        Documentación — Fotos
                    </div>
                    <div class="ds-section__body">
                        <ng-container *ngIf="imgs.length > 0; else noFotos">
                            <app-ofertas-gallery
                                [imagenes]="imgs"
                                [id_usuario]="usuario._id"
                            ></app-ofertas-gallery>

                            <h4 class="solicitud__sub">Listado de imágenes</h4>
                            <div class="ds-list">
                                <div class="ds-list__item" *ngFor="let img of imgs">
                                    <span class="ds-list__item-icon material-icons">image</span>
                                    <span class="ds-list__item-label">{{ nombresImagenes[img] || img }}</span>
                                    <span class="ds-list__item-actions">
                                        <button type="button" class="ds-pill ds-pill--outline ds-pill--sm" (click)="verImagen(img)">
                                            <span class="material-icons">visibility</span> Ver
                                        </button>
                                        <button type="button" class="ds-pill ds-pill--primary ds-pill--sm" (click)="descargarImagenPDF(img)">
                                            <span class="material-icons">picture_as_pdf</span> PDF
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </ng-container>

                        <ng-template #noFotos>
                            <div class="ds-alert ds-alert--info">
                                <span class="material-icons">photo_library</span>
                                <div>No se encontraron fotos.</div>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <!-- Documentación - Archivos -->
                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">folder</span>
                        Documentación — Archivos
                    </div>
                    <div class="ds-section__body">
                        <ng-container *ngIf="files.length > 0; else noArchivos">
                            <app-ofertas-files [files]="files" [usuario]="usuario"></app-ofertas-files>
                        </ng-container>

                        <ng-template #noArchivos>
                            <div class="ds-alert ds-alert--info">
                                <span class="material-icons">folder_off</span>
                                <div>No se encontraron archivos.</div>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <!-- Acciones: descargar PDFs (misma jerarquía que documentación) -->
                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">picture_as_pdf</span>
                        Acciones
                    </div>
                    <div class="ds-section__body">
                        <p class="solicitud__texto">
                            Usted va a descargar dos archivos PDF: uno con la documentación cargada y otro con los datos de inscripción y la DDJJ.
                        </p>
                        <div class="solicitud__actions">
                            <button type="button" class="ds-pill ds-pill--primary"
                                (click)="exportarPDFs()" [disabled]="exportandoPDFs">
                                <span class="material-icons">download</span> Descargar PDFs
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Detalles de la solicitud (después de documentación) -->
                <app-ofertas-estado-detalle
                    seccion="detalles"
                    [solicitud]="solicitud"
                    [usuario]="usuario"
                    [beneficiario]="beneficiario"
                    [nombrePais]="nombrePais"
                    [estadoDocumentacion]="estadoDocumentacion"
                    [esSedeInscripcion]="esSedeInscripcion"
                ></app-ofertas-estado-detalle>

                <!-- Historial de estados -->
                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">history</span>
                        Historial de estados
                    </div>
                    <div class="ds-section__body">
                        <div class="ds-timeline" *ngIf="historialConUsuario.length; else noHistorial">
                            <div class="ds-timeline__item"
                                *ngFor="let hs of historialConUsuario; let last = last"
                                [class.ds-timeline__item--current]="last">
                                <span class="ds-timeline__dot"></span>
                                <span class="ds-timeline__date">{{ hs.updatedAt | date: 'dd/MM/yyyy HH:mm' }}</span>
                                <span class="ds-timeline__title">{{ hs.numberState | estadosPipe }} — {{ hs.userName || 'Sistema' }}</span>
                                <span class="ds-timeline__text">{{ hs.observaciones || 'Sin observaciones' }}</span>
                            </div>
                        </div>

                        <ng-template #noHistorial>
                            <div class="ds-alert ds-alert--info">
                                <span class="material-icons">history</span>
                                <div>No hay historial de estados disponible.</div>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <!-- Alertas de estado -->
                <ng-container
                    *ngIf="
                        flagEnRevision ||
                            flagEnAuditoria ||
                            flagLabelAprobado ||
                            flagLabelRechazado ||
                            flagLabelEnEspera ||
                            flagLabelPresentado ||
                            flagLabelCompleta;
                        else incompleteAlert
                    "
                >
                    <div class="ds-alert ds-alert--warning" *ngIf="flagLabelEnEspera">
                        <span class="material-icons">hourglass_empty</span>
                        <div><strong>Solicitud en espera.</strong> Motivo: {{ solicitud.lastState?.observaciones || 'Sin especificar' }}</div>
                    </div>
                    <div class="ds-alert ds-alert--info" *ngIf="flagEnRevision">
                        <span class="material-icons">rate_review</span>
                        <div>Solicitud en revisión por parte de la sede.</div>
                    </div>
                    <div class="ds-alert ds-alert--info" *ngIf="flagEnAuditoria">
                        <span class="material-icons">fact_check</span>
                        <div>Solicitud en Auditoría médica.</div>
                    </div>
                    <div class="ds-alert ds-alert--success" *ngIf="flagLabelAprobado">
                        <span class="material-icons">check_circle</span>
                        <div>Solicitud aprobada.</div>
                    </div>
                    <div class="ds-alert ds-alert--danger" *ngIf="flagLabelRechazado">
                        <span class="material-icons">block</span>
                        <div><strong>Solicitud anulada.</strong> Motivo: {{ solicitud.lastState?.observaciones || 'Sin especificar' }}</div>
                    </div>
                    <div class="ds-alert ds-alert--info" *ngIf="flagLabelPresentado">
                        <span class="material-icons">description</span>
                        <div>Solicitud presentada.</div>
                    </div>
                    <div class="ds-alert ds-alert--success" *ngIf="flagLabelCompleta">
                        <span class="material-icons">task_alt</span>
                        <div><strong>Inscripción completa.</strong> El afiliado completó la inscripción y presentó la Declaración Jurada.</div>
                    </div>
                </ng-container>

                <!-- Inscripción + DDJJ (visible) -->
                <div class="ds-card" *ngIf="datosInscripcionCompleta">
                    <div class="ds-section__head">
                        <span class="material-icons">assignment</span>
                        Inscripción y Declaración Jurada
                    </div>
                    <div class="ds-section__body">
                        <div class="data-section">
                            <div class="section-header">
                                <h5>Datos de Inscripción</h5>
                            </div>

                            <!-- Datos del Titular -->
                            <div class="data-subsection">
                                <div class="subsection-header">
                                    <h6>Titular</h6>
                                </div>
                                <div class="data-grid">
                                    <div class="data-column">
                                        <div class="data-field">
                                            <span class="field-label">Nombre completo:</span>
                                            <span class="field-value">
                                                {{ datosInscripcionCompleta.datosDelTitular.nombre }}
                                                {{ datosInscripcionCompleta.datosDelTitular.apellido }}
                                            </span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">DNI:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDelTitular.numeroDocumento }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">CUIL:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDelTitular.cuil }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Email:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDelTitular.email }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Teléfono:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDelTitular.telefono }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Celular:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDelTitular.celular }}</span>
                                        </div>
                                    </div>
                                    <div class="data-column">
                                        <div class="data-field">
                                            <span class="field-label">Fecha Nacimiento:</span>
                                            <span class="field-value">{{ formatearFecha(datosInscripcionCompleta.datosDelTitular.fechaNacimiento) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Sexo:</span>
                                            <span class="field-value">{{ mostrarSexo(datosInscripcionCompleta.datosDelTitular.sexo) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Nacionalidad:</span>
                                            <span class="field-value">{{ mostrarNacionalidad(datosInscripcionCompleta.datosDelTitular.nacionalidad) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Estado Civil:</span>
                                            <span class="field-value">{{ mostrarEstadoCivil(datosInscripcionCompleta.datosDelTitular.estadoCivil) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Régimen Laboral:</span>
                                            <span class="field-value">{{ mostrarRegimenLaboral(datosInscripcionCompleta.datosDelTitular.regimenLaboral) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Tipo Documento:</span>
                                            <span class="field-value">{{ mostrarTipoDocumento(datosInscripcionCompleta.datosDelTitular.tipoDocumento) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Fecha Ingreso Empresa:</span>
                                            <span class="field-value">{{ formatearFecha(datosInscripcionCompleta.datosDelTitular.fechaIngresoEmpresa) }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Domicilio del Titular -->
                                <div class="address-section">
                                    <div class="subsection-header">
                                        <h6>Domicilio</h6>
                                    </div>
                                    <div class="address-content">
                                        {{ datosInscripcionCompleta.datosDelTitular.domicilio.direccion }}
                                        {{ datosInscripcionCompleta.datosDelTitular.domicilio.numero }}
                                        <span *ngIf="datosInscripcionCompleta.datosDelTitular.domicilio.piso">
                                            - Piso: {{ datosInscripcionCompleta.datosDelTitular.domicilio.piso }}
                                        </span>
                                        <span *ngIf="datosInscripcionCompleta.datosDelTitular.domicilio.departamento">
                                            Dpto: {{ datosInscripcionCompleta.datosDelTitular.domicilio.departamento }}
                                        </span>
                                        <br />
                                        {{ datosInscripcionCompleta.datosDelTitular.domicilio.localidad }},
                                        {{ datosInscripcionCompleta.datosDelTitular.domicilio.provincia }}
                                        (CP: {{ datosInscripcionCompleta.datosDelTitular.domicilio.codigoPostal }})
                                    </div>
                                </div>
                            </div>

                            <!-- Datos de la Empresa -->
                            <div class="data-subsection" *ngIf="datosInscripcionCompleta.datosDelTitular.regimenLaboral !== 1">
                                <div class="subsection-header">
                                    <h6>Datos de la Empresa</h6>
                                </div>
                                <div class="data-grid">
                                    <div class="data-column">
                                        <div class="data-field">
                                            <span class="field-label">Razón Social:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDeLaEmpresa.razonSocial }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">CUIT:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDeLaEmpresa.cuit }}</span>
                                        </div>
                                    </div>
                                    <div class="data-column">
                                        <div class="data-field">
                                            <span class="field-label">Domicilio:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDeLaEmpresa.domicilio }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Teléfono:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDeLaEmpresa.telefono }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Familiares -->
                            <div class="data-subsection" *ngIf="datosInscripcionCompleta.familiares.length > 0">
                                <div class="subsection-header">
                                    <h6>Familiares Declarados</h6>
                                </div>
                                <div class="family-list">
                                    <div *ngFor="let familiar of datosInscripcionCompleta.familiares; let i = index" class="family-member">
                                        <div class="member-header">Familiar {{ i + 1 }}</div>
                                        <div class="data-grid">
                                            <div class="data-column">
                                                <div class="data-field">
                                                    <span class="field-label">Nombre:</span>
                                                    <span class="field-value">{{ familiar.nombre }} {{ familiar.apellido }}</span>
                                                </div>
                                                <div class="data-field">
                                                    <span class="field-label">DNI:</span>
                                                    <span class="field-value">{{ familiar.numeroDocumento }}</span>
                                                </div>
                                                <div class="data-field">
                                                    <span class="field-label">Parentesco:</span>
                                                    <span class="field-value">{{ mostrarParentesco(familiar.parentesco) }}</span>
                                                </div>
                                                <div class="data-field">
                                                    <span class="field-label">Fecha Nacimiento:</span>
                                                    <span class="field-value">{{ formatearFecha(familiar.fechaNacimiento) }}</span>
                                                </div>
                                            </div>
                                            <div class="data-column">
                                                <div class="data-field">
                                                    <span class="field-label">Sexo:</span>
                                                    <span class="field-value">{{ mostrarSexo(familiar.sexo) }}</span>
                                                </div>
                                                <div class="data-field">
                                                    <span class="field-label">Nacionalidad:</span>
                                                    <span class="field-value">{{ mostrarNacionalidad(familiar.nacionalidad) }}</span>
                                                </div>
                                                <div class="data-field">
                                                    <span class="field-label">Email:</span>
                                                    <span class="field-value">{{ familiar.email || "No especificado" }}</span>
                                                </div>
                                                <div class="data-field">
                                                    <span class="field-label">CUIL:</span>
                                                    <span class="field-value">{{ familiar.cuil || "No especificado" }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Declaración Jurada (visible) -->
                <div class="ds-card" *ngIf="datosInscripcionCompleta && solicitud.ddjj?.acepta && solicitud.ddjj?.contenido">
                    <div class="ds-section__head">
                        <span class="material-icons">fact_check</span>
                        Declaración Jurada
                    </div>
                    <div class="ds-section__body">
                        <div class="data-section">
                            <div class="section-header">
                                <h5>Declaración Jurada</h5>
                            </div>

                            <!-- Datos Personales DDJJ -->
                            <div class="data-subsection">
                                <div class="subsection-header">
                                    <h6>Datos Personales</h6>
                                </div>
                                <div class="data-grid">
                                    <div class="data-column">
                                        <div class="data-field">
                                            <span class="field-label">Nombre:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.nombre }} {{ datosInscripcionCompleta.ddjj.datosPersonales.apellido }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">DNI:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.dni }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Fecha Nacimiento:</span>
                                            <span class="field-value">{{ formatearFecha(datosInscripcionCompleta.ddjj.datosPersonales.fechaNacimiento) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Domicilio:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.domicilio }}</span>
                                        </div>
                                    </div>
                                    <div class="data-column">
                                        <div class="data-field">
                                            <span class="field-label">Localidad:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.localidad }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Teléfono:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.telefono }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Empleador:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.empleador }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">CUIT:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.cuit }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="data-field-full">
                                    <span class="field-label">Grupo Sanguíneo:</span>
                                    <span class="field-value">{{ mostrarGrupoSanguineo(datosInscripcionCompleta.ddjj.datosPersonales.grupoSanguineo) }}</span>
                                    <span class="field-label ml-3">Factor RH:</span>
                                    <span class="field-value">{{ mostrarFactorRh(datosInscripcionCompleta.ddjj.datosPersonales.factorRh) }}</span>
                                </div>
                                <div class="data-field-full" *ngIf="datosInscripcionCompleta.ddjj.datosPersonales.otros">
                                    <span class="field-label">Otros datos:</span>
                                    <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.otros }}</span>
                                </div>
                            </div>

                            <!-- Secciones de salud (tarjetas jerárquicas: padre SÍ/NO + hijos) -->
                            <ng-container *ngFor="let seccion of getDdjjSecciones()">
                                <div class="ddjj-seccion">
                                    <h6 class="ddjj-seccion__titulo">{{ seccion.titulo }}</h6>
                                    <div class="ddjj-grid">
                                        <div class="ddjj-item" *ngFor="let item of seccion.items">
                                            <div class="ddjj-item__head">
                                                <span class="ddjj-item__label">{{ item.label }}</span>
                                                <span class="ddjj-badge"
                                                    *ngIf="item.tipo === 'siNo'"
                                                    [ngClass]="item.tiene ? 'ddjj-badge--si' : 'ddjj-badge--no'">
                                                    {{ item.tiene ? 'SÍ' : 'NO' }}
                                                </span>
                                            </div>

                                            <div class="ddjj-item__valor" *ngIf="item.tipo === 'texto'">
                                                {{ item.valor || '—' }}
                                            </div>

                                            <div class="ddjj-hijos"
                                                *ngIf="item.hijos && item.hijos.length && (item.tipo !== 'siNo' || item.tiene)">
                                                <div class="ddjj-child" *ngFor="let hijo of item.hijos">
                                                    <span class="ddjj-child__label">{{ hijo.label }}</span>
                                                    <span class="ddjj-badge"
                                                        *ngIf="hijo.tipo === 'siNo'"
                                                        [ngClass]="hijo.tiene ? 'ddjj-badge--si' : 'ddjj-badge--no'">
                                                        {{ hijo.tiene ? 'SÍ' : 'NO' }}
                                                    </span>
                                                    <span class="ddjj-child__valor" *ngIf="hijo.tipo === 'texto'">
                                                        {{ hijo.valor || '—' }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- Información de aceptación -->
                            <div class="declaration-summary">
                                <div class="summary-header">Declaración Jurada Completada</div>
                                <div class="summary-content">
                                    <div class="data-field">
                                        <span class="field-label">Fecha de declaración:</span>
                                        <span class="field-value">{{ formatearFechaHora(solicitud.ddjj.timeMark) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- DDJJ no completada -->
                <div class="ds-card" *ngIf="datosInscripcionCompleta && !(solicitud.ddjj?.acepta && solicitud.ddjj?.contenido)">
                    <div class="ds-section__head">
                        <span class="material-icons">fact_check</span>
                        Declaración Jurada
                    </div>
                    <div class="ds-section__body">
                        <div class="ds-alert ds-alert--warning">
                            <span class="material-icons">priority_high</span>
                            <div><strong>Importante:</strong> El afiliado aún no ha completado la Declaración Jurada.</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ---------- Columna derecha ---------- -->
            <div class="solicitud__col">
                <!-- Aprobar -->
                <div class="ds-card" *ngIf="activarAprobar">
                    <div class="ds-section__head">
                        <span class="material-icons">verified</span>
                        Aprobar
                    </div>
                    <div class="ds-section__body">
                        <p class="solicitud__texto">
                            Si todo está correcto, aprueba la solicitud y se notificará al afiliado.
                        </p>

                        <label class="ds-switch">
                            <input type="checkbox" [(ngModel)]="isCheckedAprobar">
                            <span class="ds-switch__track"><span class="ds-switch__thumb"></span></span>
                            <span class="ds-switch__label">Activar aprobación</span>
                        </label>

                        <ng-container *ngIf="isCheckedAprobar">
                            <div class="ds-alert ds-alert--info">
                                <span class="material-icons">info</span>
                                <div><strong>Proceso de Inscripción:</strong> se verificará en GECROS y se procesarán los familiares automáticamente.</div>
                            </div>
                            <div class="solicitud__actions">
                                <button type="button" class="ds-pill ds-pill--primary"
                                    (click)="aprobarSolicitudInscripcion()" [disabled]="flagSpinner">
                                    <span class="material-icons">check_circle</span> Aprobar Inscripción
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Poner en Espera -->
                <div class="ds-card" *ngIf="activarEnEspera">
                    <div class="ds-section__head">
                        <span class="material-icons">hourglass_empty</span>
                        Poner en Espera
                    </div>
                    <div class="ds-section__body">
                        <div class="ds-alert ds-alert--warning">
                            <span class="material-icons">priority_high</span>
                            <div>Al poner en espera la solicitud, se notificará al afiliado y quedará en estado de espera hasta nueva revisión.</div>
                        </div>

                        <label class="ds-switch">
                            <input type="checkbox" [(ngModel)]="isCheckedEnEspera">
                            <span class="ds-switch__track"><span class="ds-switch__thumb"></span></span>
                            <span class="ds-switch__label">Activar para poner en espera</span>
                        </label>

                        <ng-container *ngIf="isCheckedEnEspera">
                            <div class="ds-textarea">
                                <label class="ds-textarea__label" for="motivoEspera">Motivo de la espera</label>
                                <textarea id="motivoEspera" class="ds-textarea__control" [(ngModel)]="motivoEspera"
                                    (input)="habilitarBotonEspera(motivoEspera)"
                                    placeholder="Describa el motivo por el cual se pone en espera..."></textarea>
                            </div>

                            <div class="solicitud__actions">
                                <button type="button" class="ds-pill ds-pill--primary"
                                    [disabled]="!habilitarEnviarEspera"
                                    (click)="actualizarEstadoSolicitud(this.solicitud._id, this.iAppOfertas.estado_6.number, false, this.iAppOfertas.estado_6.name, true, motivoEspera)">
                                    Poner en Espera
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Anular -->
                <div class="ds-card" *ngIf="activarRechazar">
                    <div class="ds-section__head">
                        <span class="material-icons">block</span>
                        Anular
                    </div>
                    <div class="ds-section__body">
                        <div class="ds-alert ds-alert--danger">
                            <span class="material-icons">warning</span>
                            <div>Al <strong>ANULAR</strong> una solicitud, el afiliado tendrá que reenviar la autorización y su documentación nuevamente.</div>
                        </div>

                        <label class="ds-switch">
                            <input type="checkbox" [(ngModel)]="isCheckedRechazar">
                            <span class="ds-switch__track"><span class="ds-switch__thumb"></span></span>
                            <span class="ds-switch__label">Active la opción para anular</span>
                        </label>

                        <ng-container *ngIf="isCheckedRechazar">
                            <div class="ds-textarea">
                                <label class="ds-textarea__label" for="motivoRechazo">Motivo de anulación</label>
                                <textarea id="motivoRechazo" class="ds-textarea__control" [(ngModel)]="motivoRechazo"
                                    (input)="habilitarBotonAnulacion(motivoRechazo)"
                                    placeholder="Escriba el motivo por el cual se anula la solicitud..."></textarea>
                            </div>

                            <div class="solicitud__actions">
                                <button type="button" class="ds-pill ds-pill--primary"
                                    [disabled]="!habilitarEnviarAnulacion"
                                    (click)="actualizarEstadoSolicitud(this.solicitud._id, this.iAppOfertas.estado_5.number, false, this.iAppOfertas.estado_5.name, true, motivoRechazo)">
                                    Anular
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Observación Interna -->
                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">lock</span>
                        Observación Interna
                    </div>
                    <div class="ds-section__body">
                        <div class="ds-alert ds-alert--info">
                            <span class="material-icons">info</span>
                            <div>Visible solo para administradores. No se comparte con el afiliado.</div>
                        </div>

                        <div class="ds-textarea">
                            <label class="ds-textarea__label" for="observacionInterna">Observación interna (no visible para el afiliado)</label>
                            <textarea id="observacionInterna" class="ds-textarea__control" [(ngModel)]="observacionInterna"
                                (input)="habilitarBotonObservacionesInternas(observacionInterna)"
                                placeholder="Escriba una observación interna sobre esta solicitud..."></textarea>
                        </div>

                        <div class="solicitud__actions">
                            <button type="button" class="ds-pill ds-pill--primary"
                                [disabled]="!habilitarGuardarObservacionInterna"
                                (click)="guardarObservacionInterna()">
                                Guardar Observación Interna
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Deshacer Anulación -->
                <div class="ds-card" *ngIf="flagLabelRechazado">
                    <div class="ds-section__head">
                        <span class="material-icons">undo</span>
                        Deshacer Anulación
                    </div>
                    <div class="ds-section__body">
                        <p class="solicitud__texto">La solicitud pasará a revisión.</p>
                        <div class="solicitud__actions">
                            <button type="button" class="ds-pill ds-pill--outline"
                                [disabled]="!activarDeshacerAnulacion" (click)="deshacerAnulacion()">
                                Deshacer Anulación
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="ds-modal__actions" *ngIf="flagLoaded">
        <button type="button" class="ds-pill ds-pill--ghost" (click)="closeModal()">Cerrar</button>
    </div>

    <ng-template #incompleteAlert>
        <div class="ds-alert ds-alert--danger">
            <span class="material-icons">warning</span>
            <div>El afiliado no completó la solicitud y la dejó parcial sin la documentación mínima.</div>
        </div>
    </ng-template>

    <!-- ===== Contenedor OCULTO para exportación limpia a PDF (NO TOCAR) ===== -->
    <div id="export-inscripcion-ddjj-pdf" *ngIf="flagLoaded"
        style="display: none;">
    
        <!-- Página 1: Inscripción (datos del titular, domicilio, empresa, familiares) -->
        <div class="page-a4">
            <h2 style="margin:0 0 10px;">Inscripción y Declaración Jurada</h2>
            <p><strong>Solicitud N°:</strong> {{ solicitud?._nro || solicitud?._id }}</p>
            <h3 style="border-bottom:1px solid #ccc; margin-top:10px;">Datos de Inscripción</h3>

            <h4>Titular</h4>
            <div style="display:flex; flex-wrap:wrap;">
            <div style="flex:1; min-width:250px;">
                <p><strong>Nombre completo:</strong> {{ datosInscripcionCompleta?.datosDelTitular?.nombre }} {{ datosInscripcionCompleta?.datosDelTitular?.apellido }}</p>
                <p><strong>DNI:</strong> {{ datosInscripcionCompleta?.datosDelTitular?.numeroDocumento }}</p>
                <p><strong>CUIL:</strong> {{ datosInscripcionCompleta?.datosDelTitular?.cuil }}</p>
                <p><strong>Email:</strong> {{ datosInscripcionCompleta?.datosDelTitular?.email }}</p>
                <p><strong>Teléfono:</strong> {{ datosInscripcionCompleta?.datosDelTitular?.telefono }}</p>
                <p><strong>Celular:</strong> {{ datosInscripcionCompleta?.datosDelTitular?.celular }}</p>
            </div>
            <div style="flex:1; min-width:250px;">
                <p><strong>Fecha Nacimiento:</strong> {{ formatearFecha(datosInscripcionCompleta?.datosDelTitular?.fechaNacimiento) }}</p>
                <p><strong>Sexo:</strong> {{ mostrarSexo(datosInscripcionCompleta?.datosDelTitular?.sexo) }}</p>
                <p><strong>Nacionalidad:</strong> {{ mostrarNacionalidad(datosInscripcionCompleta?.datosDelTitular?.nacionalidad) }}</p>
                <p><strong>Estado Civil:</strong> {{ mostrarEstadoCivil(datosInscripcionCompleta?.datosDelTitular?.estadoCivil) }}</p>
                <p><strong>Régimen Laboral:</strong> {{ mostrarRegimenLaboral(datosInscripcionCompleta?.datosDelTitular?.regimenLaboral) }}</p>
                <p><strong>Tipo Documento:</strong> {{ mostrarTipoDocumento(datosInscripcionCompleta?.datosDelTitular?.tipoDocumento) }}</p>
                <p><strong>Fecha Ingreso Empresa:</strong> {{ formatearFecha(datosInscripcionCompleta?.datosDelTitular?.fechaIngresoEmpresa) }}</p>
            </div>
            </div>

            <h4>Domicilio</h4>
            <p>
            {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.direccion }}
            {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.numero }}
            <span *ngIf="datosInscripcionCompleta?.datosDelTitular?.domicilio?.piso"> - Piso: {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.piso }} </span>
            <span *ngIf="datosInscripcionCompleta?.datosDelTitular?.domicilio?.departamento"> Dpto: {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.departamento }} </span>
            <br/>
            {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.localidad }}, {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.provincia }} (CP: {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.codigoPostal }})
            </p>

            <div *ngIf="datosInscripcionCompleta?.datosDelTitular?.regimenLaboral !== 1">
            <h4>Datos de la Empresa</h4>
            <p><strong>Razón Social:</strong> {{ datosInscripcionCompleta?.datosDeLaEmpresa?.razonSocial }}</p>
            <p><strong>CUIT:</strong> {{ datosInscripcionCompleta?.datosDeLaEmpresa?.cuit }}</p>
            <p><strong>Domicilio:</strong> {{ datosInscripcionCompleta?.datosDeLaEmpresa?.domicilio }}</p>
            <p><strong>Teléfono:</strong> {{ datosInscripcionCompleta?.datosDeLaEmpresa?.telefono }}</p>
            </div>

            <div *ngIf="datosInscripcionCompleta?.familiares?.length">
            <h4>Familiares Declarados</h4>
            <div *ngFor="let familiar of datosInscripcionCompleta.familiares; let i = index" style="margin-bottom:8px; border:1px solid #ddd; padding:6px;">
                <strong>Familiar {{ i + 1 }}</strong>
                <p><strong>Nombre:</strong> {{ familiar.nombre }} {{ familiar.apellido }}</p>
                <p><strong>DNI:</strong> {{ familiar.numeroDocumento }}</p>
                <p><strong>Parentesco:</strong> {{ mostrarParentesco(familiar.parentesco) }}</p>
                <p><strong>Fecha Nacimiento:</strong> {{ formatearFecha(familiar.fechaNacimiento) }}</p>
                <p><strong>Sexo:</strong> {{ mostrarSexo(familiar.sexo) }}</p>
                <p><strong>Nacionalidad:</strong> {{ mostrarNacionalidad(familiar.nacionalidad) }}</p>
                <p><strong>Email:</strong> {{ familiar.email || 'No especificado' }}</p>
                <p><strong>CUIL:</strong> {{ familiar.cuil || 'No especificado' }}</p>
            </div>
            </div>
        </div>

        <!-- Página 2: DDJJ - Datos Personales, Antecedentes Médicos, Hábitos Fisiológicos, Hábitos Tóxicos, Gineco-Obstétricos -->
        <div class="page-a4" *ngIf="solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido">
            <h3 style="border-bottom:1px solid #ccc; margin-top:0;">Declaración Jurada</h3>

            <h4>Datos Personales</h4>
            <p><strong>Nombre:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.nombre }} {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.apellido }}</p>
            <p><strong>DNI:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.dni }}</p>
            <p><strong>Fecha Nacimiento:</strong> {{ formatearFecha(datosInscripcionCompleta?.ddjj?.datosPersonales?.fechaNacimiento) }}</p>
            <p><strong>Domicilio:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.domicilio }}</p>
            <p><strong>Localidad:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.localidad }}</p>
            <p><strong>Teléfono:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.telefono }}</p>
            <p><strong>Empleador:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.empleador }}</p>
            <p><strong>CUIT:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.cuit }}</p>
            <p><strong>Grupo Sanguíneo:</strong> {{ mostrarGrupoSanguineo(datosInscripcionCompleta?.ddjj?.datosPersonales?.grupoSanguineo) }} - <strong>Factor RH:</strong> {{ mostrarFactorRh(datosInscripcionCompleta?.ddjj?.datosPersonales?.factorRh) }}</p>
            <p *ngIf="datosInscripcionCompleta?.ddjj?.datosPersonales?.otros"><strong>Otros:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.otros }}</p>

            <h4>Antecedentes Médicos</h4>
            <p>{{ mostrarAntecedentesMedicos(datosInscripcionCompleta?.ddjj?.antecedentesMedicos) || 'No especificado' }}</p>

            <h4>Hábitos Fisiológicos</h4>
            <p>{{ mostrarHabitosFisiologicos(datosInscripcionCompleta?.ddjj?.habitosFisiologicos) || 'No especificado' }}</p>

            <h4>Hábitos Tóxicos</h4>
            <p>{{ mostrarHabitosToxicos(datosInscripcionCompleta?.ddjj?.habitosToxicos) || 'No especificado' }}</p>

            <h4>Antecedentes Gineco-Obstétricos</h4>
            <p>{{ mostrarAntecedentesGinecoObstetricos(datosInscripcionCompleta?.ddjj?.antecedentesGinecoObstetricos) || 'No especificado' }}</p>
        </div>

        <!-- Páginas siguientes: cada grupo de antecedentes en su propia página, si existen datos -->
        <div class="page-a4" *ngIf="solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido && datosInscripcionCompleta?.ddjj?.antecedentesFamiliares">
            <h4>Antecedentes Familiares</h4>
            <div *ngFor="let key of objectKeys(datosInscripcionCompleta.ddjj.antecedentesFamiliares)" style="margin-bottom:4px;">
            <strong>{{ formatKey(key) }}:</strong>
            {{ mostrarSiNo(datosInscripcionCompleta.ddjj.antecedentesFamiliares[key].tiene) }}
            <span *ngIf="datosInscripcionCompleta.ddjj.antecedentesFamiliares[key].tiene && obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesFamiliares[key])">
                - {{ obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesFamiliares[key]) }}
            </span>
            </div>
        </div>

        <div class="page-a4" *ngIf="solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido && datosInscripcionCompleta?.ddjj?.antecedentesPatologicos">
            <h4>Antecedentes Patológicos</h4>
            <div *ngFor="let key of objectKeys(datosInscripcionCompleta.ddjj.antecedentesPatologicos)" style="margin-bottom:4px;">
            <strong>{{ formatKey(key) }}:</strong>
            {{ mostrarSiNo(datosInscripcionCompleta.ddjj.antecedentesPatologicos[key].tiene) }}
            <span *ngIf="datosInscripcionCompleta.ddjj.antecedentesPatologicos[key].tiene && obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesPatologicos[key])">
                - {{ obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesPatologicos[key]) }}
            </span>
            </div>
        </div>

        <div class="page-a4" *ngIf="solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido && datosInscripcionCompleta?.ddjj?.sintomasYExperiencias">
            <h4>Síntomas y Experiencias</h4>
            <div *ngFor="let key of objectKeys(datosInscripcionCompleta.ddjj.sintomasYExperiencias)" style="margin-bottom:4px;">
            <strong>{{ formatKey(key) }}:</strong>
            {{ mostrarSiNo(datosInscripcionCompleta.ddjj.sintomasYExperiencias[key].tiene) }}
            <span *ngIf="datosInscripcionCompleta.ddjj.sintomasYExperiencias[key].tiene && obtenerDetalle(datosInscripcionCompleta.ddjj.sintomasYExperiencias[key])">
                - {{ obtenerDetalle(datosInscripcionCompleta.ddjj.sintomasYExperiencias[key]) }}
            </span>
            </div>
        </div>

        <div class="page-a4" *ngIf="solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido && datosInscripcionCompleta?.ddjj?.antecedentesQuirurgicos">
            <h4>Antecedentes Quirúrgicos</h4>
            <div *ngFor="let key of objectKeys(datosInscripcionCompleta.ddjj.antecedentesQuirurgicos)" style="margin-bottom:4px;">
            <strong>{{ formatKey(key) }}:</strong>
            {{ mostrarSiNo(datosInscripcionCompleta.ddjj.antecedentesQuirurgicos[key].tiene) }}
            <span *ngIf="datosInscripcionCompleta.ddjj.antecedentesQuirurgicos[key].tiene && obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesQuirurgicos[key])">
                - {{ obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesQuirurgicos[key]) }}
            </span>
            </div>
        </div>

        <!-- Fecha de declaración jurada (última página opcional) -->
        <div class="page-a4" *ngIf="solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido">
            <p><strong>Fecha de declaración:</strong> {{ formatearFechaHora(solicitud?.ddjj?.timeMark) }}</p>
        </div>
        
        <!-- Si no hay DDJJ completada, mostramos aviso en una página -->
        <div class="page-a4" *ngIf="!(solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido)" style="color:#a94442; background:#f2dede; padding:10px;">
            <strong>Importante:</strong> El afiliado aún no ha completado la Declaración Jurada.
        </div>
    </div>
    <!-- FIN del contenedor oculto -->
</div>

<!-- ===== Modal de Verificación GECROS ===== -->
<div *ngIf="verificacionGecrosModal" class="gecros-overlay">
    <div class="ds-modal gecros-modal">
        <div class="ds-accent"></div>

        <div class="ds-modal__head">
            <span class="ds-modal__head-icon material-icons">verified_user</span>
            <div>
                <h2>Verificación en GECROS</h2>
                <p>
                    <ng-container *ngIf="solicitud?._nro">Solicitud Nº {{ solicitud._nro }} · </ng-container>{{ resultadosGecros.length }} persona(s)
                </p>
            </div>
            <span class="ds-modal__spacer"></span>
            <button type="button" class="ds-icon-btn" (click)="cerrarModalGecros()" aria-label="Cerrar">
                <span class="material-icons">close</span>
            </button>
        </div>

        <div class="ds-modal__body">
            <!-- Aviso según el estado de la verificación -->
            <div *ngIf="!titularValido" class="ds-alert ds-alert--danger gecros-aviso">
                <span class="material-icons">report</span>
                <div>
                    <strong>{{ titularMotivo }}</strong>
                    No se puede aprobar la inscripción hasta resolver la situación del titular.
                </div>
            </div>

            <div *ngIf="titularValido && familiaresInvalidosSinOmitir.length > 0" class="ds-alert ds-alert--warning gecros-aviso">
                <span class="material-icons">warning</span>
                <div>
                    <strong>{{ familiaresInvalidosSinOmitir.length }} familiar(es) no pasaron la verificación.</strong>
                    Quitalos de la aprobación para continuar con el titular y los familiares válidos.
                </div>
            </div>

            <div *ngIf="titularValido && familiaresInvalidosSinOmitir.length === 0" class="ds-alert ds-alert--success gecros-aviso">
                <span class="material-icons">check_circle</span>
                <div>
                    <strong>Todo listo para aprobar.</strong>
                    Se procesarán {{ personasAProcesar.length }} de {{ resultadosGecros.length }} personas<ng-container *ngIf="cantidadOmitidos > 0"> ({{ cantidadOmitidos }} familiar(es) omitido(s))</ng-container>.
                </div>
            </div>

            <div class="gecros-personas">
                <div *ngFor="let persona of resultadosGecros"
                     class="gecros-persona"
                     [ngClass]="{
                        'gecros-persona--ok': esPersonaValida(persona),
                        'gecros-persona--bad': !esPersonaValida(persona) && !familiarOmitido(persona.dni),
                        'gecros-persona--omitido': persona.tipo === 'Familiar' && familiarOmitido(persona.dni)
                     }">
                    <span class="gecros-persona__icon"
                          [ngClass]="{
                            'gecros-persona__icon--ok': esPersonaValida(persona),
                            'gecros-persona__icon--bad': !esPersonaValida(persona) && !familiarOmitido(persona.dni),
                            'gecros-persona__icon--omitido': persona.tipo === 'Familiar' && familiarOmitido(persona.dni)
                          }">
                        <span class="material-icons">
                            {{ esPersonaValida(persona) ? 'check_circle' : (persona.tipo === 'Familiar' && familiarOmitido(persona.dni) ? 'remove_circle' : 'error') }}
                        </span>
                    </span>

                    <div class="gecros-persona__info">
                        <div class="gecros-persona__tipo">{{ persona.tipo }}</div>
                        <div class="gecros-persona__nombre"
                             [class.gecros-persona__nombre--tachado]="persona.tipo === 'Familiar' && familiarOmitido(persona.dni)">
                            {{ persona.apellido }}, {{ persona.nombre }}
                        </div>
                        <div class="gecros-persona__meta">
                            <span class="gecros-persona__dni"
                                  [attr.title]="'Copiar DNI: ' + persona.dni"
                                  (click)="copiarDNI(persona.dni)">
                                DNI: {{ persona.dni }}
                            </span>
                            <span *ngIf="persona.sinGenero" class="gecros-persona__nota">sin género en GECROS</span>
                            <span *ngIf="persona.error" class="gecros-persona__nota">error al consultar</span>
                        </div>
                    </div>

                    <div class="gecros-persona__acciones">
                        <span *ngIf="esPersonaValida(persona)" class="ds-chip ds-chip--aprobado">OK</span>
                        <span *ngIf="persona.tipo === 'Familiar' && familiarOmitido(persona.dni)" class="ds-chip ds-chip--neutro">OMITIDO</span>
                        <span *ngIf="!esPersonaValida(persona) && !familiarOmitido(persona.dni)" class="ds-chip ds-chip--anulado">No válido</span>

                        <button *ngIf="persona.tipo === 'Familiar'"
                                type="button"
                                class="ds-pill ds-pill--sm"
                                [ngClass]="familiarOmitido(persona.dni) ? 'ds-pill--outline' : 'ds-pill--ghost'"
                                (click)="toggleOmitirFamiliar(persona)">
                            <span class="material-icons">{{ familiarOmitido(persona.dni) ? 'undo' : 'person_remove' }}</span>
                            {{ familiarOmitido(persona.dni) ? 'Reincorporar' : 'Quitar' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="ds-modal__actions">
            <button type="button" class="ds-pill ds-pill--ghost" (click)="cerrarModalGecros()">Cancelar</button>
            <button type="button" class="ds-pill ds-pill--primary"
                    [disabled]="!puedeConfirmarAprobacion"
                    (click)="confirmarAprobacion()">
                <span class="material-icons">check_circle</span>
                Aprobar {{ personasAProcesar.length }} de {{ resultadosGecros.length }}
            </button>
        </div>
    </div>
</div>
